module.exports = __webpack_public_path__ + "static/media/instagram.6778e050.svg";